
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { ArxivRecord } from './types';
import ArxivRecordCard from './ArxivRecordCard';

interface ArxivResultsListProps {
  hasSearched: boolean;
  records: ArxivRecord[];
  resumptionToken?: string;
  loading: boolean;
  onLoadMore: () => void;
}

const ArxivResultsList: React.FC<ArxivResultsListProps> = ({
  hasSearched,
  records,
  resumptionToken,
  loading,
  onLoadMore
}) => {
  if (!hasSearched) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Search Results ({records.length} records)</CardTitle>
        <CardDescription>
          Metadata fetched from arXiv OAI-PMH interface
        </CardDescription>
      </CardHeader>
      <CardContent>
        {records.length === 0 ? (
          <p className="text-muted-foreground">No records found for the specified criteria.</p>
        ) : (
          <div className="space-y-4">
            {records.map((record, index) => (
              <ArxivRecordCard key={`${record.id}-${index}`} record={record} index={index} />
            ))}
            
            {resumptionToken && (
              <div className="flex justify-center">
                <Button 
                  onClick={onLoadMore} 
                  disabled={loading}
                  variant="outline"
                  className="flex items-center gap-2"
                >
                  {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
                  Load More Results
                </Button>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ArxivResultsList;
